// extracted by mini-css-extract-plugin
export var fullHeightState = "_3x-7";
export var headerCell = "_3x-1";
export var loadingStateCell = "_3x-4";
export var rowWrapper = "_3x-3";
export var standaloneTable = "_3x-8";
export var standaloneTableWithBodyFill = "_3x-9";
export var stateCell = "_3x-5";
export var table = "_3x-0";
export var tableBodyFiller = "_3x-6";
export var white = "_3x-2";